/**
 * @module store/mutations
 *
 * @version 1.0.0
 * @copyright Kosmos 2019
 */

/* eslint-disable no-param-reassign */
export default {};
/* eslint-enable no-param-reassign */
